import type { QueryClient } from "@tanstack/react-query"
import { resolveUser } from "./resolve-user"
import { isTransientFailure } from "./user-query"

export async function revalidateUser(
	queryClient: QueryClient,
): Promise<"confirmed" | "lost" | "unreachable"> {
	try {
		const resolution = await resolveUser({
			queryClient,
			locationSearch: {},
			fresh: true,
		})
		if (resolution.status !== "resolved" || !resolution.user) return "lost"
		return "confirmed"
	} catch (error) {
		if (isTransientFailure(error)) return "unreachable"
		throw error
	}
}
